import { render } from "./UnattendedList.vue?vue&type=template&id=0765f9bb&ts=true"
import script from "./UnattendedList.vue?vue&type=script&lang=ts"
export * from "./UnattendedList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__